module.exports = __webpack_public_path__ + "img/logo.664e6f2b.png";